const useInAppReview = () => {
  const request = () => {
    if (window && window['ReactNativeWebView']) {
      window['ReactNativeWebView'].postMessage(
        JSON.stringify({
          type: 'REQUEST_INAPP_REVIEW',
        })
      )
    }
  }
  return {
    request: request,
  }
}

export default useInAppReview
